import { Subscription } from 'rxjs';

import { ChildWindow } from '../../embedding/child.service';

interface ViewerStatusClosed {
    state: 'closed';
}

interface ViewerStatusOpening {
    state: 'opening';
}

interface ViewerStatusOpen {
    state: 'open';
    window: ChildWindow;
    messagesSubscription: Subscription;
}

interface ViewerStatusReady {
    state: 'ready';
    window: ChildWindow;
    messagesSubscription: Subscription;
}

export type ViewerStatus = ViewerStatusClosed | ViewerStatusOpening | ViewerStatusOpen | ViewerStatusReady;

export function isViewerClosed(status: ViewerStatus): status is ViewerStatusClosed {
    return status.state === 'closed';
}

export function isViewerBusy(status: ViewerStatus): status is ViewerStatusOpening {
    return status.state === 'opening';
}

export function isViewerOpen(status: ViewerStatus): status is ViewerStatusOpen | ViewerStatusReady {
    return 'window' in status;
}

export function isViewerReady(status: ViewerStatus): status is ViewerStatusReady {
    return status.state === 'ready';
}
